import React from 'react';
import API_BASE from '../config';

function ThankYou({ registration, onBack }) {
  const hasDelegation = registration.delegation && registration.delegation.active;
  const hasLiberatoria = registration.liberatoria && registration.liberatoria.parent1 && registration.liberatoria.parent1.firstName;

  const downloadRegistrationPdf = () => {
    window.open(`${API_BASE}/registrations/token/${registration.editToken}/pdf/registration`, '_blank');
  };

  const downloadDelegationPdf = () => {
    window.open(`${API_BASE}/registrations/token/${registration.editToken}/pdf/delegation`, '_blank');
  };

  const downloadLiberatoriaPdf = () => {
    window.open(`${API_BASE}/registrations/token/${registration.editToken}/pdf/liberatoria`, '_blank');
  };

  return (
    <div className="thank-you">
      <div className="thank-you-icon">🎉</div>
      <h2>Registrazione Completata!</h2>
      <p>
        Grazie per aver registrato <strong>{registration.student.firstName} {registration.student.lastName}</strong> (Classe {registration.student.class}) alla festa di fine anno scolastico.
      </p>

      <div className="thank-you-downloads">
        <h3>Scarica i Documenti</h3>
        <p style={{ fontSize: '14px', color: '#666', marginBottom: '15px' }}>
          Stampare questi documenti e portarli alla festa.
        </p>

        <button className="btn-download" onClick={downloadRegistrationPdf}>
          📄 Conferma di Registrazione
        </button>

        {hasDelegation && (
          <button className="btn-download" onClick={downloadDelegationPdf}>
            📄 Autorizzazione alla Delega
          </button>
        )}

        {hasLiberatoria && (
          <button className="btn-download" onClick={downloadLiberatoriaPdf}>
            📄 Liberatoria (da stampare e firmare)
          </button>
        )}
      </div>

      <p style={{ fontSize: '13px', color: '#888', marginTop: '20px' }}>
        Un link per modificare la registrazione è stato inviato. Per eventuali modifiche, utilizzare il link inviato alla vostra email.
      </p>

      <button className="btn-primary" onClick={onBack} style={{ marginTop: '20px' }}>
        Torna alla Home
      </button>
    </div>
  );
}

export default ThankYou;
